import type { Timestamp } from "@firebase/firestore-types";
import { accountFullPath } from "../account/models.js";

export const logsPathFromAccount = `logs`;

export const logsFullPath = (accountId: string): string =>
  `${accountFullPath(accountId)}/${logsPathFromAccount}`;

export type Log = {
  name: string;
  createdAt: Timestamp;
} & (
  | { name: "openBanking.initialized" }
  | { name: "openBanking.returned" } // user returned from open banking provider, only for Bridge and GCL
  | { name: "openBanking.connected" }
  | { name: "openBanking.synced"; data: { transactionsSynced: number } }
  | { name: "openBanking.suspended" }
  | { name: "openBanking.error"; data: { status: string } }
  | { name: "account.created" }
  | { name: "account.archived" }
  | { name: "account.reactivated" }
  | { name: "account.invitationSent"; data: { supervisorOrgId: string } }
  | { name: "account.invitationAccepted"; data: { supervisorOrgId: string } }
  | { name: "account.invitationRefused"; data: { supervisorOrgId: string } }
  | { name: "account.invitationCanceled"; data: { supervisorOrgId: string } }
  | { name: "account.memberAdded"; data: { email: string } }
  | { name: "account.memberOnboardingSubmitted"; data: { email: string } }
  | { name: "account.memberActivated"; data: { email: string } }
  | { name: "account.memberRemoved"; data: { email: string } }
  | { name: "kycAdminReview.pending" }
  | { name: "kycAdminReview.refused"; data: { reason: string } }
  | { name: "kycAdminReview.validated" }
  | { name: "email.sent"; data: { email: string; template: string } }
  | {
      name: "email.delivered";
      data: { email: string; template: string };
    }
  | {
      name: "email.opened";
      data: { email: string; template: string };
    }
  | {
      name: "email.clicked";
      data: { email: string; template: string };
    }
  | {
      name: "email.spammed";
      data: { email: string; template: string };
    }
  | { name: "alert.balanceExceededMax"; data: { balance: number; threshold: number | null } }
  | { name: "alert.balanceFallenBelowMin"; data: { balance: number; threshold: number | null } }
  | { name: "alert.procedureCollectiveDetected"; data: { siren: string } }
  | { name: "alert.transactionAmountExceeded"; data: { amount: number; threshold: number } }
  | { name: "alert.accountInactive"; data: { days: number; since: string } } // since: ISO date of the last activity
);
